import React from 'react';
import PropTypes from 'prop-types';
import { ResultWrapper, ResultLabel } from './styles';
import * as matchStatus from '../../../constants';

const Result = ({
  awayRes, homeRes, size, margin, withCursor, status,
  isFav, isWorldCup, isMobile, awayPenRes, homePenRes, isNext,
}) => {
  const isHomeWinner = () => (Number(homeRes) + Number(homePenRes) > Number(awayRes) + Number(awayPenRes));
  const isAwayWinner = () => (Number(homeRes) + Number(homePenRes) < Number(awayRes) + Number(awayPenRes));
  const isLive = () => status === matchStatus.LIVE_STATUS;
  const displayResult = (res, penRes) => {
    if (status === matchStatus.POSTPONED_STATUS || status === matchStatus.PREMATCH_STATUS || status === matchStatus.FIXTURE) {
      return '-';
    }
    return Number(res) + Number(penRes);
  };
  return (
    <ResultWrapper
      className={isLive() ? 'liveColor' : 'black'}
      withCursor={withCursor}
      margin={margin}
      isFav={isFav}
      isCorr={isMobile}
    >
      <ResultLabel
        color={isWorldCup ? 'black' : isLive() ? 'liveColor' : 'black'}
        size={size}
        customMargin={isNext ? '0px 6px' : '8px 6px'}
        font={isWorldCup ? 'narrowRegular' : isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
        isMobile={isMobile}
      >
        {displayResult(homeRes, homePenRes)}
      </ResultLabel>
      {isWorldCup &&
        <ResultLabel
          color="black"
          size={size}
          customMargin={isNext ? '0px' : '3px 0'}
        >
          -
        </ResultLabel>
      }
      <ResultLabel
        color={isWorldCup ? 'black' : isLive() ? 'liveColor' : 'black'}
        size={size}
        customMargin={isNext ? '0px 6px' : '8px 6px'}
        font={isWorldCup ? 'narrowRegular' : isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
        isMobile={isMobile}
      >
        {displayResult(awayRes, awayPenRes)}
      </ResultLabel>
    </ResultWrapper>
  );
};

Result.propTypes = {
  awayRes: PropTypes.any,
  homeRes: PropTypes.any,
  //color: PropTypes.string,
  size: PropTypes.any,
  margin: PropTypes.any,
  withCursor: PropTypes.bool,
  isMobile: PropTypes.bool,
  isFav: PropTypes.bool,
  status: PropTypes.any,
  isWorldCup: PropTypes.any,
  awayPenRes: PropTypes.any,
  homePenRes: PropTypes.any,
  isNext: PropTypes.bool,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/TimeResults/Result/index.js